import { getLeaseOrderList } from '@/api/purchaseAndSaleAPI'

const orderState = {
  1: '已创建',
  2: '进行中',
  3: '已关闭',
}
export default function () {
  const configData = {
    formData: {
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '企业租赁订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入企业租赁订单ID',
            clearable: true,
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'startTime',
          },
        },
      ],
      dealWithSearch: this.dealWithData, // 查询
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '订单ID',
            prop: 'id',
            width: 100,
          },
        },
        {
          name: 'carTotalNum',
          columnProps: {
            label: '租赁车辆数',
            prop: 'carTotalNum',
            width: 100,

          },
        },
        {
          name: 'rentedCarNum',
          columnProps: {
            label: '已租车辆数',
            prop: 'rentedCarNum',
            width: 100,
          },
        },
        {
          name: 'returnCarNum',
          columnProps: {
            label: '订单退车数',
            prop: 'returnCarNum',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label: '客户名称',
            prop: 'customerName',
            width: 110,
          },
        },
        {
          name: 'createTime',
          columnProps: {
            label: '订单创建时间',
            prop: 'createTime',
            width: '180',
          },
        },
        {
          name: 'contractStartDate',
          columnProps: {
            label: '合同开始时间',
            prop: 'contractStartDate',
            width: 100,
          },
        },
        {
          name: 'contractEndDate',
          columnProps: {
            label: '合同结束时间',
            prop: 'contractEndDate',
            width: 100,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            prop: 'state',
          },
          getText: ({ row }) => orderState[row.state],
        },
      ],
      apiFn: getLeaseOrderList,
    },
  }
  return {
    configData,
  }
}
